var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFhsGreenArrowUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 5,
    viewBox: "0 0 6 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6391 4.92822L4.69421 4.92822C5.27306 4.92822 5.63371 4.30031 5.34205 3.80032L3.81449 1.18165C3.52508 0.685523 2.80823 0.685522 2.51883 1.18165L0.99127 3.80032C0.699607 4.30031 1.06026 4.92822 1.6391 4.92822Z",
    fill: "#398132"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFhsGreenArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FHS_green_arrow_up.b2950fa9788f459e8565d69c75a4f4ab.svg";